import Accordian from 'components/Accordian';

import { ACCORDIAN_ITEMS } from './constants';

const LayoutV2FAQs: React.FunctionComponent = function () {
  return (
    <div className="flex w-full">
      <div className="flex flex-col gap-y-4 w-full max-w-3xl mx-auto">
        <h1 className="text-20-24-em md:text-24-28-em text-neutral-900">
          Frequently Asked Questions
        </h1>
        <h3 className="text-14-22 md:text-16-24 text-neutral-700">
          Find answers to common questions about the checkout process
        </h3>
        <Accordian items={ACCORDIAN_ITEMS} />
      </div>
    </div>
  );
};

export default LayoutV2FAQs;
